import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';

export const Breakpoints = {
  BIG_DESKTOP: 2560,
  DESKTOP: 1920,
  LAPTOP: 1440,
  TABLET: 1024,
  MOBILE: MOBILE_BREAKPOINT,
};
